import { faCheck } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import TopBar from 'components/layout/TopBar';
import { formatError } from 'components/utils/FormatData';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import MyButton from '../../components/form/MyButton';
import MyForm from '../../components/form/MyForm';
import ReturnTopBar from '../../components/layout/ReturnTopBar';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';


const CreateUser = (props) => {
  const alert = useAlert();
  const history = useHistory();
  const [width, height] = useWindowSize();
  const [componentHeight, setComponentHeight] = useState(height - 295);
  const [user, setUser] = useState({
    id: '',
    login: '',
    nom: '',
    prenom: '',
    email: '',
    telephoneFixe: '',
    telephoneMobile: '',
    role: '',
  });
  const [listUsers, setListUsers] = useState([]);
  const [autocompleteLoading, setAutocompleteLoading] = useState(false);
  const form = [
    {
      id: 'nom',
      label: 'NOM',
      required: true,
      type: 'text',
      readOnly: true,
    },
    {
      id: 'prenom',
      label: 'PRÉNOM',
      required: false,
      type: 'text',
      readOnly: true,
    },
    {
      id: 'email',
      label: 'EMAIL',
      required: true,
      type: 'email',
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      errorLabel: 'Merci de renseigner un email valide',
      readOnly: true,
    },
  ];
  const secondForm = [
    {
      id: 'telephoneFixe',
      label: 'TÉL. FIXE',
      required: false,
      type: 'tel',
      pattern: /^0[1-9]([-. ]?[0-9]{2}){4}$/,
      errorLabel: 'Merci de renseigner un téléphone fixe valide',
      readOnly: true,
    },
    {
      id: 'telephoneMobile',
      label: 'TÉL. PORTABLE',
      required: false,
      type: 'tel',
      pattern: /^0[1-9]([-. ]?[0-9]{2}){4}$/,
      errorLabel: 'Merci de renseigner un téléphone portable valide',
      readOnly: true,
    },
    {
      id: 'role',
      label: 'RÔLE',
      type: 'select',
      options: [
        { value: 'ADMINISTRATEUR_FONCTIONNEL', label: 'Admin. fonctionnel' },
        { value: 'ADMINISTRATEUR_TECHNIQUE', label: 'Admin. technique' },
        { value: 'SUPERVISEUR', label: 'Superviseur' },
        { value: 'TECHNICIEN', label: 'Technicien' },
      ],
    },
  ];
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    document.title = `SED - Création d'utilisateur`;
    if (auth.profil !== 1 && auth.profil !== 2) {
      alert.error(`Vous n'êtes pas autorisé à accéder à cet écran`);
      history.push('/');
    }
  }, []);
  useEffect(() => {
    if (isMobile) {
      setComponentHeight(height - (60 + document.getElementById('component-topbar').clientHeight));
    } else {
      setComponentHeight(height - (200 + document.getElementById('component-topbar').clientHeight));
    }
  }, [width, height]);

  const handleOnChangeValue = (value, type) => {
    setUser({ ...user, [type]: value });
  };
  const handleOnValid = () => {
    if (user.login && user.nom && user.email && user.role) {

      axios({ method: 'post', url: URL_API + '/utilisateurs', data: user })
        .then(function () {
          alert.success('Le compte utilisateur [' + user.login + '] a été créé avec succès');
          history.push('/utilisateurs');
        })
        .catch(function (err) {
          formatError(alert, err);
        });

    } else {
      alert.error('Vous devez renseigner l\'ensemble des champs obligatoires avant de continuer');
    }
  };
  const handleOnInputChange = (value) => {
    if (value && value.length > 2) {
      setAutocompleteLoading(true);
      axios({ method: 'get', url: URL_API + '/ldap', params: { login: value } })
        .then(function (response) {
          setListUsers(response.data);
          setAutocompleteLoading(false);
        })
        .catch(function (err) {
          formatError(alert, err);
          setAutocompleteLoading(false);
        });
    }
  };
  const handleOnChange = (value) => {
    if (value) {
      setUser({
        ...user,
        id: value.id,
        login: value.login,
        nom: value.nom,
        prenom: value.prenom,
        email: value.email,
        telephoneFixe: value.telephoneFixe,
        telephoneMobile: value.telephoneMobile,
      });
    } else {
      setUser({
        ...user,
        id: '',
        login: '',
        nom: '',
        prenom: '',
        email: '',
        telephoneFixe: '',
        telephoneMobile: '',
      });
      setListUsers([]);
    }
  };

  if (isMobile) {
    return (
      <div id="users" className='panel-contenu-mobile-tablette' style={{ height: height - 60 }}>
        <TopBar title="création d'un nouvel utilisateur" className='topbar-contenu-mobile-tablette' color={props.params.color} buttons={<ReturnTopBar url="/utilisateurs" />} />
        <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>

          <div style={{ margin: '15px', padding: '15px', width: '85%' }}>
            <Autocomplete
              options={listUsers}
              loading={autocompleteLoading}
              onChange={(e, v) => handleOnChange(v)}
              onInputChange={(e, v) => handleOnInputChange(v)}
              getOptionLabel={(option) => option.login}
              getOptionSelected={(option, value) => option.id === value.id}
              style={{ width: '100%', margin: 'auto', marginTop: '25px' }}
              renderInput={(params) => <TextField {...params} label="LOGIN" InputLabelProps={{ shrink: true }} />}
            />

            <MyForm data={user} setData={setUser} form={form} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />
            <MyForm data={user} setData={setUser} form={secondForm} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />

            <div className="row-center" style={{ margin: '25px' }}>
              <MyButton
                className="my-button"
                type="button"
                href="#"
                label="VALIDER"
                styleCss={{ backgroundColor: '#A3C745', height: '30px' }}
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                onClick={handleOnValid}
              />
            </div>

          </div>

        </div>
      </div>
    );
  }

  return (
    <div id="users" className='panel-contenu' style={{ height: height - 110 }}>
      <TopBar title="création d'un nouvel utilisateur" className='topbar-contenu' color={props.params.color} buttons={<ReturnTopBar url="/utilisateurs" />} />
      <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>

        <div style={{ margin: '15px', padding: '15px', width: '40%' }}>
          {
            props.wsStatus &&
            <Autocomplete
              options={listUsers}
              loading={autocompleteLoading}
              onChange={(e, v) => handleOnChange(v)}
              onInputChange={(e, v) => handleOnInputChange(v)}
              getOptionLabel={(option) => option.login}
              getOptionSelected={(option, value) => option.id === value.id}
              style={{ width: '100%', margin: 'auto', marginTop: '25px', minWidth: '250px' }}
              renderInput={(params) => <TextField {...params} label="LOGIN" InputLabelProps={{ shrink: true }} />}
            />
          }
          {
            !props.wsStatus &&
            <Autocomplete
              options={listUsers}
              loading={autocompleteLoading}
              getOptionLabel={(option) => option.login}
              getOptionSelected={(option, value) => option.id === value.id}
              style={{ width: '100%', margin: 'auto', marginTop: '25px', minWidth: '250px' }}
              renderInput={(params) => <TextField {...params} label="LOGIN" InputLabelProps={{ shrink: true }} />}
              disabled
            />
          }

          <MyForm data={user} setData={setUser} form={form} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />
        </div>
        <div style={{ margin: '15px', padding: '15px', width: '40%' }}>
          <MyForm data={user} setData={setUser} form={secondForm} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />
        </div>
      </div>

      <div className="row-center">
        {
          props.wsStatus &&
          <MyButton
            className="my-button"
            type="button"
            href="#"
            label="VALIDER"
            styleCss={{ backgroundColor: '#A3C745', height: '30px' }}
            iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
            onClick={handleOnValid}
          />
        }
        {
          !props.wsStatus &&
          <MyButton
            className="my-button"
            type="button"
            href="#"
            label="VALIDER"
            styleCss={{ backgroundColor: '#8ca0a8', height: '30px', cursor: 'default' }}
            iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
          />
        }

      </div>

    </div>
  );

};

export default CreateUser;